import {getField, updateField} from "vuex-map-fields";

export const axios = require("axios");

const state = {
  admin: null
}

const getters = {
  getField,
  getAdmin(state) {
    return state.admin
  },
}

const mutations = {
  updateField,
  setAdmin(state, admin) {
    state.admin = admin
  },
}


const actions = {
  currentAdmin({commit, state}) {
    axios.get('/api/auth/admin')
      .then(response => commit('setAdmin', response.data))
      .catch(error => console.error(error))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
